import { api } from '../../client';

export interface ProjectTeamMemberDto {
  id: string;
  project_id: string;
  employee_id: string;
  employee_name: string;
  department: string;
  job_title: string;
  hourly_rate: number;
}

export const projectsTeamApi = {
  async list(projectId: string): Promise<{ data?: ProjectTeamMemberDto[]; message?: string }> {
    return api.get(
      `/projects/team-composition?project_id=${encodeURIComponent(projectId)}`
    ) as Promise<{ data: ProjectTeamMemberDto[] }>;
  },

  async add(
    projectId: string,
    data: { employee_id: string; hourly_rate?: number }
  ): Promise<{ data?: ProjectTeamMemberDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/projects/team-composition', { project_id: projectId, ...data }) as Promise<{
      data: ProjectTeamMemberDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    _projectId: string,
    memberId: string,
    data: { hourly_rate?: number }
  ): Promise<{ data?: ProjectTeamMemberDto; message?: string }> {
    return api.put(`/projects/team-composition/${memberId}`, data) as Promise<{
      data: ProjectTeamMemberDto;
      message?: string;
    }>;
  },

  async remove(_projectId: string, memberId: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/projects/team-composition/${memberId}`) as Promise<{
      success?: boolean;
      message?: string;
    }>;
  },
};
